import { render, staticRenderFns } from "./bshrc.vue?vue&type=template&id=4a87b7db&scoped=true"
import script from "./bshrc.vue?vue&type=script&lang=js"
export * from "./bshrc.vue?vue&type=script&lang=js"
import style0 from "./bshrc.vue?vue&type=style&index=0&id=4a87b7db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a87b7db",
  null
  
)

export default component.exports